import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex wrap g0" }
const _hoisted_2 = {
  class: "header-text",
  style: {"width":"180px"}
}
const _hoisted_3 = { style: {"font-size":"15px"} }
const _hoisted_4 = {
  class: "header-text",
  style: {"width":"350px"}
}
const _hoisted_5 = { style: {"font-size":"15px"} }
const _hoisted_6 = {
  key: 0,
  class: "header-text no-mobile",
  style: {"width":"200px"}
}
const _hoisted_7 = {
  key: 1,
  class: "text-red"
}
const _hoisted_8 = { class: "flex align-center" }
const _hoisted_9 = {
  key: 0,
  src: "/ico/reheating.svg"
}
const _hoisted_10 = {
  key: 1,
  src: "/ico/cooling.svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskStatus = _resolveComponent("TaskStatus")!
  const _component_TemperatureControlResultRow = _resolveComponent("TemperatureControlResultRow")!
  const _component_SeTable = _resolveComponent("SeTable")!
  const _component_PostponedTaskRow = _resolveComponent("PostponedTaskRow")!
  const _component_SeExpendable = _resolveComponent("SeExpendable")!

  return (_openBlock(), _createBlock(_component_SeExpendable, {
    ref: "expendable",
    headerSize: 20
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.DateUtils.formatDateWithTime(
                _ctx.TaskManager.getDisplayDate(_ctx.taskWrapper.task!)
              )), 1)
        ]),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.taskWrapper.task!.name), 1)
        ]),
        (_ctx.taskWrapper.task.employee != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.taskWrapper.task!.employee?.name) + " " + _toDisplayString(_ctx.taskWrapper.task!.employee?.surname), 1))
          : _createCommentVNode("", true),
        (_ctx.hasInvalidResults)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Hors plage"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.mode == 'reheating')
          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.mode == 'cooling')
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true),
        _createVNode(_component_TaskStatus, {
          task: _ctx.taskWrapper.task
        }, null, 8, ["task"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.taskWrapper.task?.postponed_task == null)
        ? (_openBlock(), _createBlock(_component_SeTable, {
            key: 0,
            widths: [5, 20, 20, 20, 20],
            columns: [
        '',
        _ctx.Lang.getI18N('name'),
        _ctx.Lang.getI18N('start-temperature'),
        _ctx.Lang.getI18N('end-temperature'),
        _ctx.Lang.getI18N('temperature-control-duration'),

        _ctx.Lang.getI18N('comment'),
      ]
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskWrapper.results, (result) => {
                return (_openBlock(), _createBlock(_component_TemperatureControlResultRow, { result: result }, null, 8, ["result"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["columns"]))
        : (_openBlock(), _createBlock(_component_SeTable, {
            key: 1,
            widths: [5, 5, 5],
            columns: [
        _ctx.Lang.getI18N('postpone-date'),
        _ctx.Lang.getI18N('period'),
        _ctx.Lang.getI18N('employee'),
      ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PostponedTaskRow, {
                task: _ctx.taskWrapper.task
              }, null, 8, ["task"])
            ]),
            _: 1
          }, 8, ["columns"]))
    ]),
    _: 1
  }, 512))
}